import { createRouter, createWebHistory } from "vue-router"
import Events from "@/views/Events.vue"
import EventCRUD from "@/views/EventCRUD.vue"
import { Layout } from "@/types/theme.d"
import { authCheck } from "@/utils/auth"
import { registerChunkLoadRecovery } from "@/utils/chunkLoadRecovery"
import Content from "@/views/Content.vue"

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			redirect: () => {
				// the function receives the target route as the argument
				// we return a redirect path/location here.
				return { path: '/login' }
			},
		},
		{
			path: "/events_list",
			name: "Events",
			component: Events,
			meta: { title: "Events page", auth: true, roles: "all" }
		},
		{
			path: "/events",
			name: "Event Add",
			component: EventCRUD,
			meta: { title: "Add event", auth: true, roles: "all" }
		},
		{
			path: "/events/:api_key",
			name: "Event Update",
			component: EventCRUD,
			meta: { title: "Event CRUD page", auth: true, roles: "all", showMenu: true }
		},
		{
			path: "/demos_list",
			name: "Demos",
			component: () => import("@/views/Demos.vue"),
			meta: { title: "Events page", auth: true, roles: "all" }
		},
		{
			path: "/profile",
			name: "Profile",
			component: () => import("@/views/Profile.vue"),
			meta: { title: "Profile", auth: true, roles: "all", showMenu: true }
		},
		{
			path: "/events/dashboard/:api_key",
			name: "Dashboard",
			component: () => import("@/views/Dashboard.vue"),
			meta: { title: "Dashboard", auth: true, roles: "all", showMenu: true }
		},
		// {
		// 	path: "/events/activity/:api_key",
		// 	name: "ActivityConfiguration",
		// 	component: () => import("@/views/ActivityConfiguration.vue"),
		// 	meta: { title: "ActivityConfiguration", auth: true, roles: "all", showMenu: true }
		// },
		{
			path: "/event/:api_key",
			name: "Event",
			component: () => import("@/views/instructor/InstructorGateway.vue"),
			meta: { title: "Event", auth: false, roles: "all", forceLayout: Layout.Blank }
		},
		{
			path: "/ranking/:api_key",
			name: "Ranking",
			component: () => import("@/views/public-views/PublicViewRankingGateway.vue" ),
			meta: { title: "Ranking", auth: false, roles: "all", forceLayout: Layout.Blank}
		},
		{
			path: "/final_images/:api_key",
			name: "FinalImages",
			component: () => import("@/views/public-views/action_challenge/FinalImages.vue" ),
			meta: { title: "Ranking", auth: false, roles: "all", forceLayout: Layout.Blank}
		},
		{
			path: "/team_pick/:api_key",
			name: "TeamPickview",
			component: () => import("@/views/public-views/TeamPickview.vue" ),
			meta: { title: "TeamPickview", auth: false, roles: "all", forceLayout: Layout.Blank}
		},
		{
			path: "/musical_bingo/:api_key",
			name: "MusicalBingo",
			component: () => import("@/views/public-views/musiclBingo/PublicView.vue" ),
			meta: { title: "Ranking", auth: false, roles: "all", forceLayout: Layout.Blank}
		},
		{
			path: "/player_view/:api_key",
			name: "PlayerViewEvent",
			component: () => import("@/views/player-views/Event.vue" ),
			meta: { title: "PlayerViewEvent", auth: false, roles: "all", forceLayout: Layout.Blank}
		},
		{
			path: "/player_view/:api_key/:team_api_key",
			name: "PlayerView",
			component: () => import("@/views/player-views/PlayerView.vue" ),
			meta: { title: "PlayerView", auth: false, roles: "all", forceLayout: Layout.Blank}
		},
		
		// {
		// 	path: "/",
		// 	name: "PlayerHome",
		// 	component: () => import("@/views/player-views/Home.vue" ),
		// 	meta: { title: "PlayerHome", auth: false, roles: "all", forceLayout: Layout.Blank}
		// },
		{
			path: "/results/:api_key",
			name: "Results",
			component: () => import("@/views/public-views/PublicViewResultsGateway.vue"),
			meta: { title: "Results", auth: false, roles: "all", forceLayout: Layout.Blank}
		},
		{
			path: "/custom_view/:api_key",
			name: "CustomView",
			component: () => import("@/views/public-views/CustomViewGateway.vue"),
			meta: { title: "CustomView", auth: false, roles: "all", forceLayout: Layout.Blank}
		},
		{
			path: "/event_lobby/:url_events",
			name: "EventLobby",
			component: () => import("@/views/public-views/EventLobby.vue"),
			meta: { title: "Event Lobby", auth: false, roles: "all", forceLayout: Layout.Blank}
		},
		{
			path: "/testing",
			name: "TestingPage",
			component: () => import("@/views/public-views/TestingPage.vue"),
			meta: { title: "Testing", auth: false, roles: "all", forceLayout: Layout.Blank }
		},
		{
			path: "/login",
			name: "Login",
			component: () => import("@/views/Auth/Login.vue"),
			meta: { title: "Login", forceLayout: Layout.Blank, checkAuth: true }
		},
		{
			path: "/logout",
			name: "Logout",
			redirect: "/login"
		},
		{
			path: "/ingredient/:api_key",
			name: "Ingredint List",
			component: () => import("@/views/Tapas/IngredientList.vue"),
			meta: { title: "PlayerHome", auth: false, roles: "all", forceLayout: Layout.Blank}
		},
		{
			path: "/common-sense/customize/:custom_uuid/preview",
			name: "CommonSenseCustomizationPreview",
			component: () => import("@/views/customization/common_sense/CommonSenseCustomizationPreviewView.vue"),
			meta: {
				title: "Common Sense preview",
				auth: false,
				roles: "all",
				forceLayout: Layout.Blank,
			},
		},
		{
			path: "/common-sense/customize/:custom_uuid/preview/challenge/:challenge_id",
			name: "CommonSenseCustomizationChallengePreview",
			component: () => import("@/views/customization/common_sense/CommonSenseCustomizationPreviewView.vue"),
			meta: {
				title: "Common Sense challenge preview",
				auth: false,
				roles: "all",
				forceLayout: Layout.Blank,
			},
		},
		{
			path: "/common-sense/customize/:custom_uuid",
			name: "CommonSenseCustomization",
			component: () => import("@/views/customization/common_sense/CommonSenseCustomizationView.vue"),
			meta: {
				title: "Common Sense customization",
				auth: false,
				roles: "all",
				forceLayout: Layout.Blank,
			},
		},
		{
			path: "/customitzation/commonsense/:custom_uuid",
			redirect: (to) => ({
				path: `/common-sense/customize/${String(to.params.custom_uuid ?? "")}`,
			}),
		},
		{
			path: "/customization/commonsense/:custom_uuid",
			redirect: (to) => ({
				path: `/common-sense/customize/${String(to.params.custom_uuid ?? "")}`,
			}),
		},
		{
			path: "/:pathMatch(.*)*",
			name: "NotFound",
			component: () => import("@/views/NotFound.vue"),
			meta: { forceLayout: Layout.Blank }
		},
		{
			path: "/content",
			name: "Content",
			component: Content,
			meta: { title: "Content page", auth: true, roles: "all" }
		},
		{
			path: "/content/:name_id",
			name: "ActivityType",
			component: () => import("@/views/Content/TypeContent.vue"),
			meta: { title: "Activity Type page", auth: true, roles: "all" }
		},
		{
			path: "/content/:name_id/:type",
			name: "ContentTypeAdd",
			component: () => import("@/views/Content/CRUDGateway.vue"),
			meta: { title: "Content Type Add page", auth: true, roles: "all" }
		},
		// PREVIEW IPAD 
		{
			path: "/content_preview/:name_id/:id",
			name: "Content Preview",
			component: () => import("@/views/Content/Preview/GatewayPreview.vue"),
			meta: { forceLayout: Layout.Blank, title: "Content Preview", auth: true, roles: "all" }
		},
		{
			path: "/content/:name_id/:type/:id",
			name: "ContentTypeEdit",
			component: () => import("@/views/Content/CRUDGateway.vue"),
			meta: { title: "Content Type Edit page", auth: true, roles: "all" }
		},

		// config ERP
		{
			path: "/organization/:id?",
			name: "organization",
			component: () => import("@/views/ERP/configuration/organization/organization.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/app-personalization",
			name: "AppPersonalization",
			component: () => import("@/views/ERP/configuration/personalization/AppPersonalization.vue"),
			meta: { title: "App Personalization", auth: true, roles: "all" }
		},
		{
			path: "/activities",
			name: "Actividades",
			component: () => import("@/views/ERP/configuration/activity/activities.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/activities/activity",
			name: "ActividadesDetailNew",
			component: () => import("@/views/ERP/configuration/activity/activitiesDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/activities/activity/:id",
			name: "ActividadesDetail",
			component: () => import("@/views/ERP/configuration/activity/activitiesDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		//event service
		{
			path: "/eventService",
			name: "EventService",
			component: () => import("@/views/ERP/configuration/eventService/eventService.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/eventService/eventService",
			name: "EventServiceDetailNew",
			component: () => import("@/views/ERP/configuration/eventService/eventServiceDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/eventService/eventService/:id",
			name: "EventServiceDetail",
			component: () => import("@/views/ERP/configuration/eventService/eventServiceDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},

		{
			path: "/extras/",
			name: "extras",
			component: () => import("@/views/ERP/configuration/extras/ExtrasList.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/extras/extras_detail/",
			name: "ExtrasDetailNew",
			component: () => import("@/views/ERP/configuration/extras/ExtrasDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/extras/extras_detail/:id",
			name: "ExtrasDetail",
			component: () => import("@/views/ERP/configuration/extras/ExtrasDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		
		{
			path: "/final_budget/",
			name: "finalBudget",
			component: () => import("@/views/ERP/configuration/finalBudget/FinalBudgetList.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/final_budget/budgetPage/",
			name: "FinalBudgetNew",
			component: () => import("@/views/ERP/configuration/finalBudget/FinalBudgetDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/final_budget/budgetPage/:id",
			name: "FinalBudgetDetail",
			component: () => import("@/views/ERP/configuration/finalBudget/FinalBudgetDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/question_booking",
			name: "QuestionBookingList",
			component: () => import("@/views/ERP/configuration/questionBooking/QuestionBookingList.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/question_booking/question_booking_detail/",
			name: "QuestionBookingDetailNew",
			component: () => import("@/views/ERP/configuration/questionBooking/QuestionBookingDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/question_booking/question_booking_detail/:id",
			name: "QuestionBookingDetail",
			component: () => import("@/views/ERP/configuration/questionBooking/QuestionBookingDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/credits/consumption",
			name: "CreditsConsumption",
			component: () => import("@/views/ERP/configuration/credits/CreditConsumption.vue"),
			meta: { title: "Credit Consumption", auth: true, roles: "all" }
		},
		{
			path: "/favorite_photos",
			name: "FavoritePhotos",
			component: () => import("@/views/ERP/configuration/favoritePhotos/FavoritePhotosList.vue"),
			meta: { title: "Favorite Photos", auth: true, roles: "all" }
		},
		{
			path: "/changelog",
			name: "Changelog",
			component: () => import("@/views/ERP/changelog/ChangelogList.vue"),
			meta: { title: "What's new", auth: true, roles: "all" }
		},

		// SALES MODULE

		// BUDGET 
		{
			path: "/budget/",
			name: "Budget",
			component: () => import("@/views/ERP/budget/BudgetList.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/budget/budgetdetail/",
			name: "BudgetDetailNew",
			component: () => import("@/views/ERP/budget/BudgetDetails.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/budget/budgetdetail/:id",
			name: "BudgetDetail",
			component: () => import("@/views/ERP/budget/BudgetDetails.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		

		// Clients 
		{
			path: "/client/",
			name: "Client",
			component: () => import("@/views/ERP/client/ClientList.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/client/clientdetail/:id",
			name: "ClientDetail",
			component: () => import("@/views/ERP/client/ClientDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},

		// Clients 

		{
			path: "/booking/booking_detail_client/:api_key",
			name: "BookingDetailClient",
			component: () => import("@/views/ERP/booking/BookingDetailClient.vue"),
			meta: { title: "Booking Detail", auth: false, roles: "all", forceLayout: Layout.Blank }
		},

		// GAME MASTERS

		{
			path: "/booking/booking_detail_gm/:id",
			name: "BookingDetailGM",
			component: () => import("@/views/ERP/booking/BookingDetailGM.vue"),
			meta: { title: "Booking Detail", auth: true, roles: "all" }
		},

		// Players
		{
			path: "/games/:api_key",
			name: "PlayerHome",
			component: () => import("@/views/player-views/Home.vue" ),
			meta: { title: "PlayerHome", auth: false, roles: "all", forceLayout: Layout.Blank}
		},

		// BOOKING

		// Calendar

		{
			path: "/calendar/",
			name: "Calendar",
			component: () => import("@/views/ERP/booking/calendar/Calendar.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},

		// List
		
		{
			path: "/booking_list/",
			name: "BookingList",
			component: () => import("@/views/ERP/booking/BookingList.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/booking/booking_detail/",
			name: "BookingDetailNew",
			component: () => import("@/views/ERP/booking/BookingDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/booking/booking_detail/:id",
			name: "BookingDetail",
			component: () => import("@/views/ERP/booking/BookingDetail.vue"),
			meta: { title: "Settings Type Edit page", auth: true, roles: "all" }
		},
		{
			path: "/booking/summaries",
			name: "MonitorSummaries",
			component: () => import("@/views/ERP/booking/MonitorSummaries.vue"),
			meta: { title: "Monitor Summaries", auth: true, roles: "all" }
		},
		{
			path: "/booking/add_staff",
			name: "Staff",
			component: () => import("@/views/ERP/booking/Staff.vue"),
			meta: { title: "Staff", auth: true, roles: "all" }
		},
		{
			path: "/booking/my_activities",
			name: "StaffGM",
			component: () => import("@/views/ERP/booking/StaffGM.vue"),
			meta: { title: "My Activities", auth: true, roles: "all" }
		},

		// SLACK 
		{
			path: "/organization/slack",
			name: "InstallSlack",
			component: () => import("@/views/ERP/slack/InstallSlack.vue"),
			meta: { title: "Install Slack", auth: true, roles: "all" }
		},
		
		{
			path: '/user',
			name: 'UserSettings',
			component: () => import("@/views/User.vue"),
			meta: { title: "User Settings", auth: true, roles: "all" }
		},
		{
			path: '/analytics',
			name: 'Analytics',
			component: () => import("@/views/ERP/analytis/Analytics.vue"),
			meta: { title: "Analytics", auth: true, roles: "all" }
		},
	]
	
})

router.beforeEach(route => {
	return authCheck(route)
})

registerChunkLoadRecovery(router)

export default router